export const subscriptions = [
  {
    id: '1',
    chargebeePlanId: 'presence_monthly-USD-Yearly',
    type: 'popular',
    name: `annual \n membership`,
    price: '70',
    duration: 'year',
  },
  {
    id: '2',
    chargebeePlanId: 'presence_monthly-USD-Monthly',
    type: 'Basic',
    name: `Monthly \n Membership`,
    price: '10',
    duration: 'month',
  },
]
